/**
 * @fileoverview GET handler for the "/offerfit/:app_group_id/use_cases" endpoint
 */
import fetch from "@lib/fetch";
import type { Queries } from "@lib/serializeQueryObjects";
import { serializeQueryObjects } from "@lib/serializeQueryObjects";

import { reactQueryTableFetcherAdapter } from "../reactQueryFetcherAdapters";
import { offerfitAppGroupIdUseCases } from "./constants";
import type { OfferfitAppGroupIdUseCasesParams, OfferfitAppGroupIdUseCasesResult } from "./types";
import { isOfferfitAppGroupIdUseCasesResult } from "./validators";

export const getDataTableOfferfitAppGroupIdUseCases = reactQueryTableFetcherAdapter(
  offerfitAppGroupIdUseCases,
  (
    signal: AbortSignal,
    {
      appGroupId,
      query = {},
      groupby,
      limit = 20,
      start = 0,
      sortdir,
      sortby,
      tier,
      directAudience,
    }: OfferfitAppGroupIdUseCasesParams
  ): Promise<OfferfitAppGroupIdUseCasesResult> => {
    return fetch<OfferfitAppGroupIdUseCasesResult>(
      `/offerfit/${appGroupId}/use_cases`,
      "GET",
      {
        groupby,
        limit,
        sortby,
        sortdir,
        start,
        tier,
        direct_audience: directAudience,
        app_group_id: appGroupId,
        query: serializeQueryObjects(query as Queries),
      },
      { signal }
    );
  },
  isOfferfitAppGroupIdUseCasesResult
);
